import { cn } from '@/lib/utils';
import { Upload, FileText } from 'lucide-react';

// Shared by StepCDLMedical.jsx (onboarding) and DriverProfile.jsx (My
// Profile, post-onboarding) -- same upload-a-document-and-show-its-status
// control, so the two can't drift apart on look/behavior.
export default function UploadField({ label, url, uploading, onUpload, accept = '.pdf,.jpg,.jpeg,.png' }) {
  return (
    <div>
      <label className="text-xs text-muted-foreground block mb-1">{label}</label>
      <label className={cn(
        'flex items-center gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition-colors',
        url ? 'border-green-500/40 bg-green-500/5' : 'border-border bg-muted/40 hover:border-primary/40'
      )}>
        <input type="file" className="hidden" accept={accept} onChange={onUpload} disabled={uploading} />
        {uploading ? (
          <div className="w-4 h-4 border-2 border-border border-t-primary rounded-full animate-spin flex-shrink-0" />
        ) : url ? (
          <FileText className="w-4 h-4 text-green-400 flex-shrink-0" />
        ) : (
          <Upload className="w-4 h-4 text-muted-foreground flex-shrink-0" />
        )}
        <span className={cn('text-sm truncate', url ? 'text-green-400' : 'text-muted-foreground')}>
          {uploading ? 'Uploading…' : url ? 'Uploaded — click to replace' : `Upload ${label} (PDF, JPG, PNG)`}
        </span>
        {url && (
          <a href={url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-blue-400 hover:text-blue-300 flex-shrink-0 ml-auto text-xs">View</a>
        )}
      </label>
    </div>
  );
}
